// Centralized WhatsApp link builder for Jayapura Web Studio
export const WA_NUMBER = "6285190824646";

export function waLink(message) {
    const text =
        message ||
        "Halo Jayapura Web Studio, saya tertarik untuk konsultasi pembuatan website.";
    return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
}
